import React from "react";
import * as Icons from "lucide-react";
import { ArrowLeft, Check } from "lucide-react";
import { Btn } from "@/components/sujets/sujetsShared";

export { Btn, Chips } from "@/components/sujets/sujetsShared";

export const Icon = ({ name, size = 18, className = "" }) => { const C = Icons[name] || Icons.Circle; return <C size={size} className={className} aria-hidden="true" />; };

export const Q = ({ children, sub }) => (
  <div className="mb-6">
    <h2 className="font-serif-title text-2xl sm:text-3xl text-[var(--ink)] leading-snug" data-testid="ag-question">{children}</h2>
    {sub && <p className="text-sm text-[var(--ink-soft)] mt-2 leading-relaxed">{sub}</p>}
  </div>
);

export const Panel = ({ children, testid, className = "" }) => <div className={`rounded-3xl bg-white/80 border border-[var(--border)] p-6 sm:p-8 ${className}`} data-testid={testid}>{children}</div>;

export const TextArea = ({ value, onChange, placeholder, testid, rows = 3, autoFocus }) => (
  <textarea autoFocus={autoFocus} value={value} onChange={(e) => onChange(e.target.value)} rows={rows} placeholder={placeholder} data-testid={testid}
    className="w-full rounded-2xl bg-white border border-[var(--border)] px-4 py-3 text-[var(--ink)] leading-relaxed focus:outline-none focus:ring-2 focus:ring-[var(--gold-light)]" />
);

export const Nav = ({ onBack, onSkip, onNext, nextLabel = "Continuer →", nextDisabled, skipLabel = "Passer cette étape" }) => (
  <div className="mt-6 flex flex-wrap justify-between gap-2 no-print">
    {onBack ? <Btn secondary onClick={onBack} testid="ag-back"><ArrowLeft size={16} /> Retour</Btn> : <span />}
    <div className="flex flex-wrap gap-2">
      {onSkip && <Btn secondary onClick={onSkip} testid="ag-skip">{skipLabel}</Btn>}
      <Btn onClick={onNext} disabled={nextDisabled} testid="ag-next">{nextLabel}</Btn>
    </div>
  </div>
);

export const IconCards = ({ options, values, onToggle, testid }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid={testid}>
    {options.map((o) => {
      const on = values.includes(o.k);
      return (
        <button key={o.k} onClick={() => onToggle(o.k)} aria-pressed={on} data-testid={`${testid}-${o.k}`}
          className={`text-left rounded-2xl border-2 p-4 min-h-[88px] flex flex-col gap-2 transition-all hover:border-[var(--gold)] ${on ? "border-[var(--gold)] bg-[var(--sand)] shadow-sm" : "border-[var(--border)] bg-white"}`}>
          <span className={`w-9 h-9 rounded-full flex items-center justify-center ${on ? "bg-[var(--gold)] text-white" : "bg-[var(--sand)] text-[var(--gold)]"}`}>{on ? <Check size={16} strokeWidth={3} /> : <Icon name={o.icon} />}</span>
          <span className="text-sm font-semibold text-[var(--ink)] leading-snug">{o.label}</span>
        </button>
      );
    })}
  </div>
);

export const Scale = ({ value, onChange, min, max, testid }) => (
  <div data-testid={testid}>
    <div className="grid grid-cols-11 gap-1 sm:gap-1.5" role="radiogroup">
      {Array.from({ length: 11 }, (_, i) => (
        <button key={i} role="radio" aria-checked={value === i} onClick={() => onChange(i)} data-testid={`${testid}-${i}`}
          className={`h-11 sm:h-12 rounded-xl text-sm font-bold transition-all ${value === i ? "bg-[var(--gold)] text-white shadow-sm scale-105" : "bg-white border border-[var(--border)] text-[var(--ink)] hover:border-[var(--gold)]"}`}>{i}</button>
      ))}
    </div>
    <div className="mt-3 flex justify-between gap-4 text-xs text-[var(--ink-soft)] leading-snug"><span className="max-w-[45%]">0 — {min}</span><span className="max-w-[45%] text-right">10 — {max}</span></div>
  </div>
);

export const ProgressBar = ({ current, total, label }) => (
  <div className="mb-6 no-print" data-testid="ag-progress" aria-label="Progression">
    <div className="flex items-baseline justify-between mb-1.5"><span className="text-xs uppercase tracking-[0.18em] text-[var(--ink-soft)]">{label}</span><span className="text-xs text-[var(--ink-soft)]" data-testid="ag-progress-count">Étape {current} / {total}</span></div>
    <div className="h-1.5 w-full rounded-full bg-[var(--beige)] overflow-hidden"><div className="h-full rounded-full bg-[var(--gold)] transition-all duration-500" style={{ width: `${(current / total) * 100}%` }} /></div>
  </div>
);
